/**
 * [BLURY] | 🥭 createRandom
 * Seeded LCG, so a given seed always shuffles to the same composition.
 * @build 13.09.26
 * @updated 13.09.26 PHT
 * @author TONYTONY Sàrl
 */
export function createRandom(seed: number): () => number {
  let state = seed >>> 0;
  return () => {
    state = (state * 1664525 + 1013904223) % 4294967296;
    return state / 4294967296;
  };
}
